// import React from 'react'
import React, { useState, useEffect, useRef } from "react";
import ProductCard from '../../components/ProductCard'
import ProductDetailsCard from '../../components/ProductDetailsCard'
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";

import { getProduts, getProdutDetail } from '../../services/getProduts'

import { startProductTime } from '../../services/startProductTime';
import { endProductTime } from '../../services/endProductTime';



const Products = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { state } = useLocation();
  const { categoryID, subCategoryID, productID } = state;
  const { client_code } = params;
  const [products, setProducts] = useState();
  const [productPath, setProductPath] = useState([]);


  useEffect(() => {
    getProdutDetailData();
  }, []);

  const getProdutDetailData = async () => {
    try {
      const response = await getProdutDetail(productID);
      if (response?.status) {
        const result = response?.data?.data;
        // console.log('result', result);
        const productsPath = result?.image_path
        const products = result?.product
        setProductPath(productsPath);
        setProducts(products);
      } else {
        console.error("API response status is false:", response);
      }
    } catch (error) {
      console.error("Error in getProdutDetailData:", error);
      if (error.response) {
        console.error("API Error Response:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };

  const [catProductTime, setcatProductTime] = useState(null);
  const catProductTimeRef = useRef(null); // Use ref to store latest state

  useEffect(() => {
    const storedcatProductTime = JSON.parse(localStorage.getItem("product_time"));

    if (storedcatProductTime?.is_start_time !== "Yes") {
      enterStartProductTime();
    } else {
      setcatProductTime(storedcatProductTime);
      catProductTimeRef.current = storedcatProductTime; // Store in ref
    }

    return () => {
      // console.log("catProductTimeRef", catProductTimeRef.current);
      if (catProductTimeRef.current?.activity_id) {
        exitEndProductTime(catProductTimeRef.current.activity_id);
      }
    };
  }, []);

  const enterStartProductTime = async () => {
    try {
      const response = await startProductTime(productID);
      const activity_id = response?.data?.data?.activity_id;
      const catProductTime = { is_start_time: "Yes", activity_id: activity_id };

      localStorage.setItem("product_time", JSON.stringify(catProductTime));
      setcatProductTime(catProductTime);
      catProductTimeRef.current = catProductTime; // Update ref
    } catch (error) {
      console.error("Error in enterStartProductTime:", error);
    }
  };

  const exitEndProductTime = async (activityId) => {
    try {
      const response = await endProductTime(productID, activityId);
      console.log("response", response);
      localStorage.removeItem("product_time");
    } catch (error) {
      console.error("Error in exitEndProductTime:", error);
    }
  };


  return (
    <div className="grid grid-cols-1 gap-6">
      <div className="col-span-12">
        <button type="button"
          onClick={() => navigate(-1)}
          className="inline-flex items-center border border-indigo-300 px-2 py-1 rounded-md bg-[#AD826D] text-white hover:bg-white-50">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" className="h-4 w-4">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18">
            </path>
          </svg>
          <span className="ml-1 font-bold text-sm">Back</span>
        </button>
      </div>
      {products ? (
        <ProductDetailsCard
          categoryID={products.category_id}
          subCategoryID={products.subcategory_id}
          id={products.product_id}
          title={products.name}
          image={`${productPath}/${products.image}`}
          weight={products.weight}
          description={products.description}
        />
      ) : (
        <div className="col-span-12 flex justify-center items-center">
          <div className="w-60 grid gap-4 text-center">
            <svg
              className="mx-auto"
              xmlns="http://www.w3.org/2000/svg"
              width="154"
              height="161"
              viewBox="0 0 154 161"
              fill="none"
            >
              <path
                d="M0.0616455 84.4268C0.0616455 42.0213 34.435 7.83765 76.6507 7.83765C118.803 7.83765 153.224 42.0055 153.224 84.4268C153.224 102.42 147.026 118.974 136.622 132.034C122.282 150.138 100.367 161 76.6507 161C52.7759 161 30.9882 150.059 16.6633 132.034C6.25961 118.974 0.0616455 102.42 0.0616455 84.4268Z"
                fill="#EEF2FF"
              />
            </svg>
            <div>
              <h2 className="text-xl font-semibold leading-loose pb-2 text-black">
                No products found!
              </h2>
              <p className="text-base font-normal leading-relaxed pb-4 text-black">
                There are no products under this subcategory.
              </p>
            </div>
          </div>
        </div>
      )}

    </div>

  )
}

export default Products
